import * as ReactRedux from 'react-redux';

import {SigninOverlay} from "../SigninOverlay.js";
import {actionTypesForSignin, signinStatuses} from "../constants/signinOverlayConstants.js";


const mapStateToProps = (state) => {
	return {
		showSigninOverlay: state.showSigninOverlay,
		isStandAloneSignin: state.isStandAloneSignin,
		signinStatus: state.signinStatus,
		loading: state.loading
	}
};

const mapDispatchToProps = dispatch => {
	return {
		setUserCredentials: (data) => dispatch({
			type: actionTypesForSignin.SET_USERCREDENTIALS,
			username: data.userCredentials.username,
			first: data.userCredentials.first,
			signinStatus: data.userCredentials.signinStatus,
			primaryEmailHint: data.userCredentials.primaryEmailHint,
			errors: data.errors,
			messages: data.messages,
			redirectURL: data.userCredentials.redirectURL
		}),
		reinitialize: () => dispatch({
			type: actionTypesForSignin.INIT,
			data: {}
		}),
		toggleSigninOverlay: (username, first, signinStatus) => dispatch({
			type: actionTypesForSignin.TOGGLE_OVERLAY,
			username: username,
			first:first,
			signinStatus: signinStatus
		})
	};
};

export const SigninOverlayContainer = ReactRedux.connect(
		mapStateToProps,
		mapDispatchToProps,
		null,
		{ forwardRef: true }
)(SigninOverlay);
